import pricingContextModuleHelper from '@vp/pricing-context-module/helpers.js';

function getPricingContextModule() {
    return pricingContextModuleHelper.getPcxtV3();
}
function getPricingContext() {
    const module = getPricingContextModule();
    return module?.isInitialized() ? module.getPricingContext() : undefined;
}

export { getPricingContext, getPricingContextModule };
//# sourceMappingURL=module.mjs.map
